module.exports = __webpack_public_path__ + "static/media/มะโรง.492de907.jpg";